var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSentStatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7197 15.9741L18.3736 10.3202M24.1572 6.86979L19.3848 22.3801C18.9571 23.7701 18.7431 24.4655 18.3742 24.696C18.0542 24.8959 17.6581 24.9293 17.3096 24.7847C16.9078 24.618 16.5817 23.9669 15.9311 22.6657L12.9083 16.6201C12.8051 16.4136 12.7534 16.3108 12.6844 16.2214C12.6232 16.142 12.5526 16.0704 12.4732 16.0092C12.3858 15.9418 12.2847 15.8913 12.0874 15.7927L6.02792 12.7629C4.72673 12.1123 4.07608 11.7867 3.90935 11.3849C3.76476 11.0365 3.79773 10.6399 3.99765 10.32C4.22817 9.95104 4.92345 9.7367 6.31389 9.30888L21.8242 4.53646C22.9174 4.20012 23.4641 4.03208 23.8334 4.16763C24.155 4.28569 24.4085 4.53899 24.5266 4.8606C24.6621 5.22964 24.4939 5.77615 24.1579 6.86818L24.1572 6.86979Z",
    stroke: "#AF976E",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSentStatus);
export default __webpack_public_path__ + "static/media/sent_status.28a4de6ec046bf6cec849eb6870ff4a0.svg";
export { ForwardRef as ReactComponent };